import { render, staticRenderFns } from "./ExitApproval.vue?vue&type=template&id=2db2345a&scoped=true&"
import script from "./ExitApproval.vue?vue&type=script&lang=js&"
export * from "./ExitApproval.vue?vue&type=script&lang=js&"
import style0 from "./ExitApproval.vue?vue&type=style&index=0&id=2db2345a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2db2345a",
  null
  
)

export default component.exports